export * from 'SourceRoute/CategoryPage/CategoryPage.config';
export const SCROLL_TO_TOP_TIMEOUT = 800;
export const PREVIOUS_CATEGORY_URL_COOKIE = 'previous_category_link';
export const ONLINE_FROM_ATTRIBUTE = 'online_from';
export const DEFAULT_ONLINE_FROM_DIRECTION = 'DESC';
